export enum VantaResultExportType {
    PrettifiedJson = 'PrettifiedJson',
    CsvExport = 'CsvExport',
    // PdfExport = 'PdfExport'
}
